import React from 'react';
import PropTypes from 'prop-types';
import { SpacerVertical } from '@klarna/bubble-ui';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';

import SummaryPerson from './SummaryPerson';
import { CY_APPLICATION_OVERVIEW_PAGE_IDS } from './constants';

const { STAKEHOLDER_BLOCK } = CY_APPLICATION_OVERVIEW_PAGE_IDS;

const Stakeholders = ({ type, stakeholders, role }) =>
  stakeholders
    .filter(s => s.type !== 'COMPANY')
    .map((stakeholder, index) => (
      <div
        key={`summary-stakeholders-${type}-${index}`}
        {...generateCyElemId(`${STAKEHOLDER_BLOCK}_${role}_${index}`, window)}
      >
        <SummaryPerson stakeholder={stakeholder} />
        {index < stakeholders.length - 1 && <SpacerVertical spaceToken="space/300" />}
      </div>
    ));

Stakeholders.propTypes = {
  role: PropTypes.string.isRequired,
  stakeholders: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

export default Stakeholders;
